export * from './search-result/content.search.result.component';
export * from './detail/contest.detail.component';
export * from './join-contest/join.contest.component';
export * from './submissions/contest.submissions.component';
export * from './artist/contest.artist.component';



// WEBPACK FOOTER //
// ./src/components/contest/index.ts